import React from 'react';
import clsx from 'clsx';

// Flat rounded rectangle, no shadow, generous padding (mockup report/attorney cards).
// Named ContentCard (file) / exported as Card to avoid colliding with the existing
// components/ui/Card.jsx (still used by Dashboard.jsx pre-Phase-2 re-skin).
const VARIANTS = {
  report: 'bg-accent',
  reportAlt: 'bg-accent-alt',
  attorney: 'bg-sage',
  plain: 'bg-gray-100',
};

export function Card({ variant = 'plain', children, className = '' }) {
  return (
    <div className={clsx('rounded-3xl p-6', VARIANTS[variant], className)}>
      {children}
    </div>
  );
}
